var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: { id: "codigo", placeholder: "Escriba el código..." },
                model: {
                  value: _vm.form.codigo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "codigo", $$v)
                  },
                  expression: "form.codigo"
                }
              },
              [
                _vm._v("\n          Código\n          "),
                _vm.errores.codigo
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [_c("strong", [_vm._v(_vm._s(_vm.errores.codigo[0]))])]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c(
          "div",
          { staticClass: "form-field" },
          [
            _c(
              "input-field",
              {
                attrs: {
                  id: "descripcion",
                  placeholder: "Escriba la descripción..."
                },
                model: {
                  value: _vm.form.descripcion,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "descripcion", $$v)
                  },
                  expression: "form.descripcion"
                }
              },
              [
                _vm._v("\n          Descripción\n          "),
                _vm.errores.descripcion
                  ? _c(
                      "span",
                      {
                        staticClass: "helper-text text-danger",
                        attrs: { slot: "helper" },
                        slot: "helper"
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.errores.descripcion[0]))
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo,
                    expression: "form.tipo"
                  }
                ],
                attrs: { name: "tipo", id: "tipo" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "I" } }, [_vm._v("Ingreso")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "G" } }, [_vm._v("Descuento")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo" } }, [_vm._v("Tipo")])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select" }, [
          _c("div", { staticClass: "select-field" }, [
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.form.tipo_aplicacion,
                    expression: "form.tipo_aplicacion"
                  }
                ],
                attrs: { name: "tipo_aplicacion", id: "tipo" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.form,
                      "tipo_aplicacion",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  }
                }
              },
              [
                _c("option", { attrs: { value: "V" } }, [_vm._v("Vendedor")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "S" } }, [_vm._v("Supervisor")]),
                _vm._v(" "),
                _c("option", { attrs: { value: "R" } }, [_vm._v("Recaudador")])
              ]
            ),
            _vm._v(" "),
            _c("label", { attrs: { for: "tipo_aplicacion" } }, [
              _vm._v("Tipo de aplicación")
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "modal-buttons" }, [
      _c("button", { staticClass: "btn-success", on: { click: _vm.guardar } }, [
        _c("i", { staticClass: "fa fa-save" }),
        _c("span", [_vm._v("Guardar")])
      ]),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-danger btn--text", on: { click: _vm.cancelar } },
        [
          _c("i", { staticClass: "fa fa-times" }),
          _c("span", [_vm._v("Cancelar")])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Tipo de movimiento de cajas")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-72e61140", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e61140","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/administrativo/TipoGasto.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-72e61140","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/administrativo/TipoGasto.vue
// module chunks = 0